import React from 'react';
import { Box, Container } from '@mui/material';

/**
 * Props for the InteriorPageLayout component
 */
interface InteriorPageLayoutProps {
  children: React.ReactNode;
}

/**
 * InteriorPageLayout component
 * 
 * A wrapper component for interior pages that provides consistent layout.
 * Breadcrumb navigation has been removed for a cleaner interface.
 * 
 * @param {InteriorPageLayoutProps} props - Component props
 */
const InteriorPageLayout: React.FC<InteriorPageLayoutProps> = ({ children }) => {
  return (
    <Box>
      <Container maxWidth="xl">
        {children}
      </Container>
    </Box>
  );
};

export default InteriorPageLayout; 